export default __webpack_public_path__ + "static/media/gambrel.1cd8985e.png";